import POST from "./ajax";

export default {
  LOGIN ({ dispatch, commit }, { uname, passwd } = {}) {
    const url = "/mch_web/v1/login";
    const params = {
      uname,
      passwd
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(() => {
        commit("IS_LOGIN");

        return dispatch("GET_USER_INFO");
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  CHECK_LOGIN ({ dispatch, commit }) {
    return dispatch("GET_USER_INFO")
      .then(data => {
        if (data) {
          commit("IS_LOGIN");
        } else {
          commit("NOT_LOGIN");
        }
      })
      .catch(() => {
        commit("HAS_LOGGED_OUT");
      });
  },

  /******************
   *  浏览器兼容相关  *
   ******************/
  BROWSER ({ dispatch, commit }, obj) {
    try {
      commit("SET_BROWSER", obj)
    } catch (error) {
      console.log(error)
    }

  },

  /**********
   *  注销  *
   **********/
  LOGOUT ({ dispatch, commit }) {
    const url = "/mch_web/v1/logout";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      {}
    )
      .then(() => {
        commit("HAS_LOGGED_OUT");
      })
      .catch(() => {
        commit("HAS_LOGGED_OUT");
      });
  },

  /**********
   *  注册  *
   **********/
  REGISTRY (
    { dispatch, commit },
    { uname, passwd, confirm_passwd, register_key }
  ) {
    const url = "/mch_web/v1/register";
    const params = {
      uname,
      passwd,
      confirm_passwd,
      register_key
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(() => {
        commit("IS_LOGIN");

        return dispatch("GET_USER_INFO");
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*********************************************************/

  /*************************
   *  从业务端进入注册页面  *
   *************************/
  START_REGISTRY ({ dispatch, commit }, { app_id, redirect_url, remark }) {
    const url = "/mch_web/v1/start_register";
    const params = {
      app_id,
      redirect_url,
      remark
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(({ register_key }) => {
        commit("SET_REGISTER_KEY", register_key);

        return Promise.resolve(register_key);
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*********************************************************/

  /*****************
   *  获取系统信息  *
   *****************/
  GET_USER_INFO ({ dispatch, commit }) {
    const url = "/mch_web/v1/user";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit(
          "SET_USER_INFO",
          Object.assign({}, data, {
            privileges:
              data.privileges && Array.isArray(data.privileges)
                ? data.privileges.slice()
                : []
          })
        );
        commit(
          "SET_MENU_LIST",
          data.privileges && Array.isArray(data.privileges)
            ? data.privileges.slice()
            : []
        );

        try {
          window.rfReport.addData((extData) => {
            extData.user_id = data.uname
          })


        } catch (error) {
          console.log('rfReport上报自定义数据报错====>', error)
        }

        dispatch("GET_MCH_DETAIL");
        // 获取全局下载列表并且启动定时器，5秒轮询获取
        dispatch("LIST_USER_DOWNLOAD");
        setInterval(() => {
          dispatch("LIST_USER_DOWNLOAD");
        }, 5 * 1000)
        return Promise.resolve(data);
      })
      .catch(res => {
        return Promise.reject(res);
      });
  },

  /*****************
   *  获取系统菜单  *
   *****************/
  GET_MENU_LIST ({ dispatch, commit, state }, force = false) {
    if (state.userInfo.uid && !force) {
      // Loaded
      return Promise.resolve(state.userInfo.privileges);
    } else {
      const url = "/mch_web/v1/user/privilege";
      const params = {};

      return POST(
        {
          dispatch,
          commit
        },
        url,
        params
      )
        .then(data => {
          const privileges =
            data.privileges && Array.isArray(data.privileges)
              ? data.privileges.slice()
              : [];
          commit("SET_MENU_LIST", privileges);
          return Promise.resolve(data);
        })
        .catch(res => {
          return Promise.reject(res);
        });
    }
  },

  /*****************
   *  获取权限列表  *
   ******************/
  GET_PRIVILEGE_LIST ({ dispatch, commit }) {
    const url = "/mch_web/v1/user/privilege";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************
   *  修改密码  *
   **************/
  EDIT_PASSWORD (
    { dispatch, commit },
    { old_passwd, new_passwd, biz_ticket = "" } = {}
  ) {
    const url = "/mch_web/v1/modify_passwd";
    const params = {
      old_passwd,
      new_passwd,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************
   *  忘记密码  *
   **************/
  FORGET_PASSWORD ({ dispatch, commit }, { new_pass_word, biz_ticket } = {}) {
    const url = "/mch_web/v1/forget_password";
    const params = {
      new_pass_word,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /******************
   *  启动信息验证  *
   ******************/
  START_VERIFY (
    { dispatch, commit },
    { verify_method, scene, opt, login_name = null, biz_ticket = null } = {}
  ) {
    const url = "/mch_web/v1/identity/start_verify";
    const params = {
      verify_method,
      scene,
      opt,
      login_name,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  获取图形验证码  *
   *******************/
  GET_CAPTCHA ({ dispatch, commit }, biz_ticket) {
    const url = "/mch_web/v1/identity/get_captcha";
    const params = {
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /************************
   *  发送短信/邮件验证码  *
   ************************/
  SEND_VERIFY_CODE (
    { dispatch, commit },
    { captcha, biz_ticket, outer_identifier = null } = {}
  ) {
    const url = "/mch_web/v1/identity/send_verify_code";
    const params = {
      captcha,
      biz_ticket,
      outer_identifier
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  验证身份有效性  *
   *******************/
  IDENTITY_VERIFY ({ dispatch, commit }, { user_verify_code, biz_ticket } = {}) {
    const url = "/mch_web/v1/identity/verify";
    const params = {
      user_verify_code,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  UPLOAD ({ dispatch, commit }, { pic_data, ext }) {
    const url = "/mch_web/v1/upload_picture";
    const params = {
      pic_data,
      ext
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*****************
   *  获取商家资料  *
   *****************/
  GET_MCH_DETAIL ({ dispatch, commit }, uname) {
    const url = "/mch_web/v1/mch_detail";
    const params = {
      uname
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    )
      .then(data => {
        commit("SET_MCH_DETAIL", data);
        return Promise.resolve(data);
      })
      .catch(res => {
        return res.code === 41015 ? Promise.resolve() : Promise.reject(res);
      });
  },

  /*********************
   *  填写企业商家资料  *
   *********************/
  FILL_COMPANY_DETAIL ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/fill_mch_info";
    // const params = { mch_name, business_license, biz_ticket,
    //   legal_per_name, resp_per_name, resp_per_id_type, resp_per_id_no, tel, settle_type, business_address, business_license_pic };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  编辑企业商家资料  *
   *********************/
  EDIT_COMPANY_DETAIL ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/modify_mch_info";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*********************
    *  编辑企业商家失败部分银行卡  *
    *********************/
  MODIFY_MCH_WALLET_INFO ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/modify_mch_wallet_info";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*************************
   *  编辑企业商家联系方式  *
   *************************/
  EDIT_COMPANY_CONTACT (
    { dispatch, commit },
    { business_address, tel, biz_ticket } = {}
  ) {
    const url = "/mch_web/v1/modify_mch_contact";
    const params = {
      business_address,
      tel,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  填写个人商家资料  *
   *********************/
  FILL_PERSON_DETAIL (
    { dispatch, commit },
    {
      mch_name,
      biz_ticket,
      resp_per_id_type,
      resp_per_id_no,
      business_address,
      business_license_pic,
      resp_per_id_positive,
      resp_per_id_opposite,
      resp_per_name,
      settle_type
    } = {}
  ) {
    const url = "/mch_web/v1/fill_person_info";
    const params = {
      mch_name,
      biz_ticket,
      resp_per_id_type,
      resp_per_id_no,
      business_address,
      business_license_pic,
      resp_per_id_positive,
      resp_per_id_opposite,
      resp_per_name,
      settle_type
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  编辑个人商家资料  *
   *********************/
  EDIT_PERSON_DETAIL (
    { dispatch, commit },
    {
      mch_name,
      biz_ticket,
      resp_per_id_type,
      resp_per_id_no,
      business_license_pic,
      resp_per_id_positive,
      resp_per_id_opposite,
      resp_per_name
    } = {}
  ) {
    const url = "/mch_web/v1/modify_person_info";
    const params = {
      mch_name,
      biz_ticket,
      resp_per_id_type,
      resp_per_id_no,
      business_license_pic,
      resp_per_id_positive,
      resp_per_id_opposite,
      resp_per_name
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  编辑个人商家联系方式  *
   *************************/
  EDIT_PERSON_CONTACT (
    { dispatch, commit },
    { business_address, biz_ticket } = {}
  ) {
    const url = "/mch_web/v1/modify_person_contact";
    const params = {
      business_address,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  撤回商家资料草稿  *
   *********************/
  REVOKE_MCH_DRAFT ({ dispatch, commit }, mch_draft_id) {
    const url = "/mch_web/v1/revoke_mch_draft";
    const params = {
      mch_draft_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*******************
   *  绑定责任人手机  *
   *******************/
  BIND_PHONE ({ dispatch, commit }, { resp_per_telephone_no, biz_ticket } = {}) {
    const url = "/mch_web/v1/bind_telephone";
    const params = {
      resp_per_telephone_no,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  修改责任人手机  *
   *******************/
  MODIFY_PHONE (
    { dispatch, commit },
    { resp_per_telephone_no, biz_ticket } = {}
  ) {
    const url = "/mch_web/v1/modify_telephone";
    const params = {
      resp_per_telephone_no,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  绑定责任人邮箱  *
   *******************/
  BIND_EMAIL ({ dispatch, commit }, { resp_per_email, biz_ticket } = {}) {
    const url = "/mch_web/v1/bind_email";
    const params = {
      resp_per_email,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  修改责任人邮箱  *
   *******************/
  MODIFY_EMAIL ({ dispatch, commit }, { resp_per_email, biz_ticket } = {}) {
    const url = "/mch_web/v1/modify_email";
    const params = {
      resp_per_email,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*****************
   *  获取账号列表  *
   *****************/
  GET_ACCOUNT_LIST (
    { dispatch, commit },
    { account_id, keyword, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/account/list";
    const params = {
      account_id,
      keyword,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*****************
   *  添加收款账号  *
   *****************/
  CREATE_ACCOUNT ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/account/create";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  获取账号详情  *
   *****************/
  GET_ACCOUNT_DETAIL ({ dispatch, commit }, account_id) {
    const url = "/mch_web/v1/account/detail";
    const params = {
      account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*****************
   *  修改账号名称  *
   *****************/
  EDIT_ACCOUNT_DETAIL ({ dispatch, commit }, { account_id, desc } = {}) {
    const url = "/mch_web/v1/account/edit";
    const params = {
      account_id,
      desc
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /**************************
   *  获取结算账号列表 - 旧  *
   **************************/
  GET_SETTLE_ACCOUNT_LIST_BY_PAYMENT_ACCOUNT_OLD (
    { dispatch, commit },
    { account_id, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/settle/accounts";
    const params = {
      account_id,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /**************************
   *  获取结算账号列表 - 新  *
   **************************/
  GET_SETTLE_ACCOUNT_LIST_BY_PAYMENT_ACCOUNT (
    { dispatch, commit },
    { account_id, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/settle/account_list2";
    const params = {
      account_id,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  修改结算账号状态  *
   *********************/
  UPDATE_SETTLE_ACCOUNT_STATUS ({ dispatch, commit }, { id, status } = {}) {
    const url = "/mch_web/v1/settle/edit_account";
    const params = {
      id,
      status
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  添加银行结算账号  *
   *********************/
  CREATE_SETTLE_ACCOUNT (
    { dispatch, commit },
    { bank_code, bank_account } = {}
  ) {
    const url = "/mch_web/v1/settle/add_account";
    const params = {
      bank_code,
      bank_account
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*************
   *  绑定账号  *
   *************/
  BIND_ACCOUNT (
    { dispatch, commit },
    { account_id, type, settle_account, biz_ticket } = {}
  ) {
    const url = "/mch_web/v1/settle/cfg";
    const params = {
      account_id,
      type,
      settle_account,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*************
   *  解绑账号  *
   *************/
  UNBIND_ACCOUNT (
    { dispatch, commit },
    { account_id, settle_account, biz_ticket } = {}
  ) {
    const url = "/mch_web/v1/settle/discfg";
    const params = {
      account_id,
      settle_account,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取结算钱包配置  *
   *********************/
  GET_WALLET_CONFIG ({ dispatch, commit }, account_id) {
    const url = "/mch_web/v1/settle/wallet/cfg";
    const params = {
      account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*********************
   *  添加结算钱包配置  *
   *********************/
  CREATE_WALLET (
    { dispatch, commit },
    { account_id, deposit_name, deposit_bank, bank_account }
  ) {
    const url = "/mch_web/v1/account/create_wallet";
    const params = {
      account_id,
      deposit_name,
      deposit_bank,
      bank_account
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*********************
   *  获取收款钱包详情  *
   *********************/
  GET_WALLET_DETAIL ({ dispatch, commit }, wallet_account_id) {
    const url = "/mch_web/v1/wallet/home";
    const params = {
      wallet_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /****************************
   *  获取收款钱包绑定账号详情  *
   ****************************/
  GET_SETTLE_CONFIG_DETAIL ({ dispatch, commit }, account_id) {
    const url = "/mch_web/v1/settle/cfg_detail";
    const params = {
      account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取结算账户列表  *
   *********************/
  GET_SETTLE_ACCOUNT_LIST (
    { dispatch, commit },
    {
      account_id,
      limit = 10,
      offset = 0,
      stat = true,
      bind_status,
      settle_type
    } = {}
  ) {
    const url = "/mch_web/v1/settle/query_settle";
    const params = {
      account_id,
      bind_status,
      settle_type,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取结算账号详情  *
   *********************/
  GET_SETTLE_ACCOUNT_DETAIL ({ dispatch, commit }, id) {
    const url = "/mch_web/v1/settle/account_detail";
    const params = {
      id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***********************
   *  结算账户绑定银行卡  *
   ***********************/
  CHANGE_ACCOUNT_BINDING_CARD (
    { dispatch, commit },
    { bank_account, bank_code } = {}
  ) {
    const url = "/mch_web/v1/wallet/bankcard/change";
    const params = {
      bank_account,
      bank_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************
   *  获取结算账户绑定收款账户列表  *
   *********************************/
  GET_SETTLE_ACCOUNT_BINDING_LIST (
    { dispatch, commit },
    { settle_rela_id, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/account/binding_list";
    const params = {
      settle_rela_id,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************
   *  获取结算账户绑定收款账户列表  *
   *********************************/
  GET_BANK_CARD_LIST (
    { dispatch, commit },
    { limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/wallet/bankcard/list";
    const params = {
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /******************
   *  验证微众钱包  *
   ******************/
  VERIFY_WALLET ({ dispatch, commit }, wallet_account_id) {
    const url = "/mch_web/v1/wallet/verify";
    const params = {
      wallet_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取富力钱包详情  *
   *********************/
  GET_WALLET_INFO ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/info";
    // const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 获取富力钱包渠道信息 *
   *********************/
  GET_WALLET_CHANNEL_INFO ({ dispatch, commit }, settle_account) {
    const url = "/mch_web/v1/wallet/tunnel_info";
    const params = {
      settle_account
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************************
   * 富力钱包安全手机验证码请求   *
   *****************************/
  SECURITY_PHONE_VERIFY_CODE (
    { dispatch, commit },
    { mobile, settle_account, type } = {}
  ) {
    const url = "/mch_web/v1/wallet/security_phone_verify_code";
    const params = {
      mobile,
      settle_account,
      type
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************************
   * 富力钱包绑定安全手机验证码请求   *
   *****************************/
  BIND_SECURITY_PHONE (
    { dispatch, commit },
    { mobile, settle_account, verify_code } = {}
  ) {
    const url = "/mch_web/v1/wallet/bind_security_phone";
    const params = {
      mobile,
      settle_account,
      verify_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************************
   * 富力钱包升级通联钱包会员协议 *
   *****************************/
  YUNST_MEMBER_CONTRACT ({ dispatch, commit }, settle_account) {
    const url = "/mch_web/v1/wallet/yunst_member_contract";
    const params = {
      settle_account,
      jump_url: encodeURIComponent("/#/reg-wallet-3")
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************************
   * 富力钱包升级通联钱包余额扣款协议 *
   *****************************/
  YUNST_BALANCE_CONTRACT ({ dispatch, commit }, settle_account) {
    const url = "/mch_web/v1/wallet/yunst_balance_contract";
    const params = {
      settle_account,
      jump_url: encodeURIComponent("/#/reg-wallet-4")
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取企业钱包流水列表  *
   *************************/
  GET_WALLET_LOG_LIST (
    { dispatch, commit },
    { start_time, end_time, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/wallet/log/list";
    const params = {
      start_time,
      end_time,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /************************
   *  发送短信/邮件验证码  *
   ************************/
  SEND_WALLET_VERIFY_CODE (
    { dispatch, commit },
    { mobile, verify_token, redirect_url } = {}
  ) {
    const url = "/mch_web/v1/wallet/send_verify_code";
    const params = {
      mobile,
      verify_token,
      redirect_url
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /************************
   *  发送短信/邮件验证码  *
   ************************/
  BIND_WALLET_WITH_VERIFY_CODE (
    { dispatch, commit },
    { mobile, verify_code } = {}
  ) {
    const url = "/mch_web/v1/wallet/bind_with_verify_code";
    const params = {
      mobile,
      verify_code,
      jump_url: "/"
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取富力钱包地址  *
   *********************/
  GET_WALLET_URL ({ dispatch, commit }) {
    const url = "/mch_web/v1/wallet/home";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取银行名称列表  *
   *********************/
  GET_BANK_CLASS_LIST ({ dispatch, commit }) {
    const url = "/mch_web/v1/wallet/bank/class_list";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取银行地区列表  *
   *********************/
  GET_BANK_AREA_LIST ({ dispatch, commit }, class_code) {
    const url = "/mch_web/v1/wallet/bank/area_list";
    const params = {
      class_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取支行名称列表  *
   *********************/
  GET_BANK_LIST ({ dispatch, commit }, { class_code, area_code }) {
    const url = "/mch_web/v1/wallet/bank/list";
    const params = {
      class_code,
      area_code
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取营销账户列表  *
   *********************/
  GET_OUTLAY_ACCOUNT_LIST (
    { dispatch, commit },
    {
      account_name,
      outlay_account_id,
      limit = 10,
      offset = 0,
      stat = true
    } = {}
  ) {
    const url = "/mch_web/v1/mch_payment/query_outlay_account";
    const params = {
      account_name,
      outlay_account_id,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  添加营销账号  *
   *****************/
  CREATE_OUTLAY_ACCOUNT ({ dispatch, commit }, account_name) {
    const url = "/mch_web/v1/mch_payment/create_outlay_account";
    const params = {
      account_name
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  编辑营销账号  *
   *****************/
  EDIT_OUTLAY_ACCOUNT (
    { dispatch, commit },
    { outlay_account_id, account_name }
  ) {
    const url = "/mch_web/v1/mch_payment/modify_outlay_account";
    const params = {
      outlay_account_id,
      account_name
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取营销账号预警配置  *
   *************************/
  GET_OUTLAY_WARNING_SETTINGS ({ dispatch, commit }) {
    const url = "/mch_web/v1/mch_payment/get_warning_settings";
    const params = {};

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  修改营销账号预警配置  *
   *************************/
  SET_OUTLAY_WARNING_SETTINGS ({ dispatch, commit }, { settings, biz_ticket }) {
    const url = "/mch_web/v1/mch_payment/set_warning_settings";
    const params = {
      settings,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取授权应用列表  *
   *********************/
  GET_AUTH_APP_LIST ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/query_app_info";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  授权应用使用营销账号  *
   *************************/
  BIND_AUTH_APP ({ dispatch, commit }, { json, biz_ticket }) {
    const url = "/mch_web/v1/mch_payment/bind_app";
    const params = {
      json,
      biz_ticket
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取营销账户详情  *
   *********************/
  GET_OUTLAY_ACCOUNT_DETAIL ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/outlay_account_detail";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取营销账户积分列表  *
   *************************/
  GET_OUTLAY_ACCOUNT_COIN_LIST (
    { dispatch, commit },
    {
      coin_id,
      outlay_account_id,
      start_date,
      end_date,
      limit = 10,
      offset = 0,
      stat = true
    } = {}
  ) {
    const url = "/mch_web/v1/mch_payment/coin_report";
    const params = {
      coin_id,
      outlay_account_id,
      start_date,
      end_date,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取营销账户积分详情  *
   *************************/
  GET_OUTLAY_ACCOUNT_COIN_DETAIL ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/coin_detail";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /********************************
   *  获取营销账户当天积分使用情况  *
   ********************************/
  GET_OUTLAY_ACCOUNT_COIN_LIVE_DETAIL ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/coin_live_detail";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取营销账户积分配置  *
   *************************/
  GET_OUTLAY_ACCOUNT_COIN_SETTINGS ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/query_coin_acl";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  设置营销账户积分配置  *
   *************************/
  SET_OUTLAY_ACCOUNT_COIN_SETTINGS (
    { dispatch, commit },
    { outlay_account_id, acl }
  ) {
    const url = "/mch_web/v1/mch_payment/edit_coin_acl";
    const params = {
      outlay_account_id,
      acl
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  获取营销账户现金券列表  *
   ***************************/
  GET_OUTLAY_ACCOUNT_COUPON_LIST (
    { dispatch, commit },
    {
      limit = 10,
      offset = 0,
      stat = true,
      package_id,
      outlay_account_id,
      start_date,
      end_date,
      app_id,
      status
    } = {}
  ) {
    const url = "/mch_web/v1/mch_payment/coupon_package_list";
    const params = {
      limit,
      offset,
      stat,
      package_id,
      outlay_account_id,
      start_date,
      end_date,
      app_id,
      status
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************************
   *  获取营销账户现金券详情  *
   ***************************/
  GET_OUTLAY_ACCOUNT_COUPON_DETAIL ({ dispatch, commit }, outlay_account_id) {
    const url = "/mch_web/v1/mch_payment/coupon_detail";
    const params = {
      outlay_account_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  提交充值申请  *
   *****************/
  APPLY_OUTLAY_ACCOUNT_RECHARGE (
    { dispatch, commit },
    {
      outer_bill_id,
      outlay_account_id,
      pic_urls,
      recharge_amount,
      recharge_type,
      remark
    }
  ) {
    const url = "/mch_web/v1/mch_payment/recharge_apply";
    const params = {
      outer_bill_id,
      outlay_account_id,
      pic_urls,
      recharge_amount,
      recharge_type,
      remark
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取充值申请列表  *
   *********************/
  GET_RECHARGE_APPLY_LIST (
    { dispatch, commit },
    {
      limit = 10,
      offset = 0,
      stat = true,
      outlay_account_id,
      status,
      biz_status,
      start_date,
      end_date
    } = {}
  ) {
    const url = "/mch_web/v1/payment/query_recharge_apply";
    const params = {
      limit,
      offset,
      stat,
      outlay_account_id,
      status,
      biz_status,
      start_date,
      end_date
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  确认充值成功  *
   *****************/
  CONFIRM_RECHARGE_APPLY ({ dispatch, commit }, apply_id) {
    const url = "/mch_web/v1/payment/confirm_recharge_apply";
    const params = {
      apply_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*************************
   *  获取余额转换套餐列表  *
   *************************/
  GET_PURCHASE_PACK_LIST (
    { dispatch, commit },
    { limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/purchase/package_list";
    const params = {
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  购买余额转换套餐  *
   *********************/
  OUTLAY_ACCOUNT_PURCHASE_APPLY (
    { dispatch, commit },
    { package_id, outlay_account_id, purchase_count, outer_bill_id } = {}
  ) {
    const url = "/mch_web/v1/purchase/purchase_apply";
    const params = {
      package_id,
      outlay_account_id,
      purchase_count,
      outer_bill_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取套餐购买列表  *
   *********************/
  GET_PURCHASE_PACK_RECORD_LIST (
    { dispatch, commit },
    { outlay_account_id, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/purchase/query_purchase";
    const params = {
      outlay_account_id,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取余额动态列表  *
   *********************/
  GET_OUTLAY_ACCOUNT_ACTIVITY_LIST (
    { dispatch, commit },
    {
      outlay_account_id,
      limit = 10,
      offset = 0,
      stat = true,
      start_date,
      end_date,
      rel_biz_type,
      status,
      log_id
    } = {}
  ) {
    const url = "/mch_web/v1/mch_payment/outlay_account_activity";
    const params = {
      outlay_account_id,
      limit,
      offset,
      stat,
      start_date,
      end_date,
      rel_biz_type,
      status,
      log_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取用户角色列表  *
   *********************/
  GET_ROLE_LIST (
    { dispatch, commit },
    { limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/role/list";
    const params = {
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /**************
   *  添加角色  *
   **************/
  CREATE_ROLE ({ dispatch, commit }, { parent_id, title, desc }) {
    const url = "/mch_web/v1/role/create";
    const params = {
      parent_id,
      title,
      desc
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /**************
   *  修改角色  *
   **************/
  EDIT_ROLE ({ dispatch, commit }, { role_id, parent_id, title, desc }) {
    const url = "/mch_web/v1/role/modify";
    const params = {
      role_id,
      parent_id,
      title,
      desc
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  修改角色状态  *
   *****************/
  UPDATE_ROLE_STATUS ({ dispatch, commit }, { role_id, status } = {}) {
    const url = "/mch_web/v1/role/status/edit";
    const params = {
      role_id,
      status
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  获取角色权限  *
   *****************/
  GET_ROLE_PRIVILEGE ({ dispatch, commit }, role_id) {
    const url = "/mch_web/v1/role/resource/list";
    const params = {
      role_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*****************
   *  修改角色权限  *
   *****************/
  EDIT_ROLE_PRIVILEGE ({ dispatch, commit }, { role_id, resource_ids } = {}) {
    const url = "/mch_web/v1/user/grant_privilege";
    const params = {
      role_id,
      resource_ids
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*******************
   *  获取子账号列表  *
   *******************/
  GET_CHILD_ACCOUNT_LIST (
    { dispatch, commit },
    { keyword, role_id, status, limit = 10, offset = 0, stat = true } = {}
  ) {
    const url = "/mch_web/v1/user/child/list";
    const params = {
      keyword,
      role_id,
      status,
      limit,
      offset,
      stat
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************
   *  添加子账号  *
   ***************/
  CREATE_CHILD_ACCOUNT (
    { dispatch, commit },
    { uname, nickname, passwd, role_id, status, mobile, email, tel } = {}
  ) {
    const url = "/mch_web/v1/user/child/create";
    const params = {
      uname,
      nickname,
      passwd,
      role_id,
      status,
      mobile,
      email,
      tel
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /***************
   *  编辑子账号  *
   ***************/
  EDIT_CHILD_ACCOUNT (
    { dispatch, commit },
    { user_id, nickname, role_id, mobile, email, tel } = {}
  ) {
    const url = "/mch_web/v1/user/child/edit";
    const params = {
      user_id,
      nickname,
      role_id,
      mobile,
      email,
      tel
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  修改子账号状态  *
   *******************/
  UPDATE_CHILD_ACCOUNT_STATUS ({ dispatch, commit }, { user_id, status } = {}) {
    const url = "/mch_web/v1/user/child/status";
    const params = {
      user_id,
      status
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*******************
   *  重置子账号密码  *
   *******************/
  RESET_CHILD_ACCOUNT_PASSWORD (
    { dispatch, commit },
    { user_id, new_passwd } = {}
  ) {
    const url = "/mch_web/v1/user/child/password/reset";
    const params = {
      user_id,
      new_passwd
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************************************************/

  /*********************
   *  获取交易流水列表  *
   *********************/
  GET_PAY_RECORD_FLOW_LIST (
    { dispatch, commit },
    {
      limit = 10,
      offset = 0,
      stat = true,
      account_id,
      bill_type,
      bill_id,
      out_trade_no,
      from_bill_date,
      to_bill_date,
      mch_id
    } = {}
  ) {
    const url = "/mch_web/v1/pay_record_flow_list";
    const params = {
      limit,
      offset,
      stat,
      account_id,
      bill_type,
      bill_id,
      out_trade_no,
      from_bill_date,
      to_bill_date,
      mch_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取交易流水列表  *
   *********************/
  EXPORT_PAY_RECORD_FLOW_LIST (
    { dispatch, commit },
    {
      account_id,
      bill_type,
      bill_id,
      out_trade_no,
      from_bill_date,
      to_bill_date,
      mch_id
    } = {}
  ) {
    const url = "/mch_web/v1/download_pay_record_flow_list";
    const params = {
      account_id,
      bill_type,
      bill_id,
      out_trade_no,
      from_bill_date,
      to_bill_date,
      mch_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取绑定的银行卡  *
   *********************/
  BANK_CARD_LIST ({ dispatch, commit }) {
    const url = "/wallet_web/v1/bank_card_list";
    return POST(
      {
        dispatch,
        commit
      },
      url
    );
  },

  /*********************
   *  富力钱包余额明细列表  *
   *********************/
  ORDER_LIST (
    { dispatch, commit },
    {
      from_time,
      to_time,
      limit = 10,
      offset = 0,
      stat = 1,
      status,
      trade_type,
      settle_id
    } = {}
  ) {
    const url = "/mch_web/v1/wallet/order_list";
    const params = {
      from_time,
      to_time,
      limit,
      offset,
      stat,
      status,
      trade_type,
      settle_id
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  富力钱包提现  *
   *********************/
  WITHDRAW ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/withdraw";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },
  /*********************
   *  富力钱包提现  *
   *********************/
  SMS_CONFIRM ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/sms_confirm";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 充值审批-查询充值申请 *
   *********************/
  QUERY_RECHARGE_APPLY (
    { dispatch, commit },
    {
      limit = 10,
      offset = 0,
      stat = true,
      outlay_account_id,
      apply_id,
      biz_status,
      start_date,
      end_date
    } = {}
  ) {
    const url = "/mch_web/v1/mch_payment/query_recharge_apply";
    const params = {
      limit,
      offset,
      stat,
      outlay_account_id,
      apply_id,
      biz_status,
      start_date,
      end_date
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 充值审批-商家确认充值 *
   *********************/
  CONFIRM_RECHARGE_APPLY ({ dispatch, commit }, apply_id) {
    const url = "/mch_web/v1/mch_payment/confirm_recharge_apply";
    const params = {
      apply_id
    };

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 保存企业商家信息草稿 *
   *********************/
  FILL_MCH_DRAFT_INFO ({ dispatch, commit }, data) {
    const url = "/mch_web/v1/cache/save_cache";
    let params = {
      data: JSON.stringify(data)
    };
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 保存个人商家信息草稿 *
   *********************/
  FILL_PERSON_DRAFT_INFO ({ dispatch, commit }, data) {
    let params = {
      data: JSON.stringify(data)
    };
    const url = "/mch_web/v1/cache/save_cache";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 获取草稿 *
   *********************/
  MCH_DRAFT_DETAIL ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/cache/get_cache";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 富力钱包解绑安全手机 *
   *********************/
  UNBIND_SECURITY_PHONE ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/unbind_security_phone";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   * 钱包配置-获取全局配置 *
   *********************/
  GET_UNI_CONFIG ({ dispatch, commit }) {
    const url = "/mch_web/v1/wallet/get_uni_config";
    return POST(
      {
        dispatch,
        commit
      },
      url
    );
  },

  /*********************
   *交易流水-获取用户交易流水 *
   *********************/
  LIST_USER_BILL ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/bill/list_user_bill";
    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  结算账户-创建商户钱包结算账号  *
   *********************/
  ADD_WALLET ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/settle/add_wallet";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  富力钱包-修改信息  *
   *********************/
  MODIFY_WALLET ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/modify";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  富力钱包-下载列表  *
   *********************/
  LIST_USER_DOWNLOAD ({ dispatch, commit }) {
    const url = "/mch_web/v1/report/list_user_download";
    return POST(
      {
        dispatch,
        commit
      },
      url
    ).then(data => {
      commit("SET_DOWN_LIST", data);
    }).catch(err => {
      console.log(err)
    })
  },

  /*********************
   *  富力钱包-修改信息  *
   *********************/
  EXPORT_ORDER_DETAIL ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/export_order_detail";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  富力钱包-查询钱包余额日志  *
   *********************/
  QUERY_WALLET_BALANCE_LOG ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/query_wallet_balance_log";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  富力钱包-查询范围内钱包余额 *
   *********************/
  QUERY_WALLET_INCOME ({ dispatch, commit }, params) {
    const url = "/mch_web/v1/wallet/query_wallet_income";

    return POST(
      {
        dispatch,
        commit
      },
      url,
      params
    );
  },

  /*********************
   *  获取商家审批信息总览 *
   *********************/
  MCH_AUDIT_STATUS ({ dispatch, commit }) {
    const url = "/mch_web/v1/mch_audit_status";

    return POST(
      {
        dispatch,
        commit
      },
      url
    );
  },

  /*********************
   *  获取商家审批信息总览 *
   *********************/
  LAST_SUCCEED_MCH_DETAIL ({ dispatch, commit }) {
    const url = "/mch_web/v1/last_succeed_mch_detail";

    return POST(
      {
        dispatch,
        commit
      },
      url
    );
  },
};
